import { type FooterProps, PROP_MAP } from './interface';

import { Devices } from '../../service/Devices';
import { FooterAccordion } from './FooterAccordion';
import { FooterLinksGrid } from '../jdsfooterlinksgrid/generated';
import { modifyProps } from '../../generators/modifyProps';

export const withLogic =
  (Component: React.ComponentType<FooterProps>): React.FC<FooterProps> =>
  (userProps: FooterProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    return (
      <Component
        {...{
          ...props,
          _platform: Devices.isDesktop() ? 'desktop' : 'mobile',
          _hasMainContainerProps: Boolean(
            props.marketplace || props.links || props.social
          ),
          copyright: props.copyright,
          _hasContentSlot: Boolean(props.links),
          _hasFooterIconLinks: Boolean(props.social),
          _hasSocialLinksContainer: Boolean(props.social || props.marketplace),
          children: Devices.isDesktop() ? (
            <FooterLinksGrid links={props.links} />
          ) : (
            <FooterAccordion links={props.links} />
          )
        }}
      />
    );
  };
export { FooterProps };
